import { useIsFetching } from "@tanstack/react-query"

import { ROADWORKS_ROOT_QUERY_KEY } from "./queries/queryKeys"

export function useIsFetchingRoadworks() {
    const isFetchingRoadworksLayers = useIsFetching({ queryKey: [ROADWORKS_ROOT_QUERY_KEY, "layer"] })
    const isFetchingLinearLocations = useIsFetching({ queryKey: [ROADWORKS_ROOT_QUERY_KEY, "linearLocations"] })

    const isFetching = isFetchingRoadworksLayers
        || isFetchingLinearLocations
    return isFetching > 0
}